import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {},
    title: {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(24),
      marginBottom: 12,
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: 700,
    },
    navActionsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(5),

      '& .MuiButton-startIcon': {
        marginRight: theme.spacing(2),
      },

      '& .MuiButton-endIcon': {
        marginLeft: theme.spacing(2),
      },
    },
    actionButton: {
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      '& span span': {
        marginRight: 4,
      },
    },
    navIcon: {
      width: 20,
      height: 20,
      color: theme.palette.common.black,
    },
    headerSection: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
      padding: 24,
      flexWrap: 'wrap',
    },
    lenderLogo: {
      width: 'auto',
      maxHeight: 160,
      maxWidth: 300,
      borderRadius: 0,
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
    listItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
    },
    listItemTitle: {
      '& span': {
        fontWeight: 700,
      },
    },
    listItemText: {
      flex: 'none',
    },
    actionSubtitle: {
      fontSize: theme.typography.pxToRem(17),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: 700,
    },
    actionContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
    },
    lenderActionButton: {
      marginLeft: theme.spacing(2),
    },
    usersContainer: {
      marginTop: theme.spacing(4),
    },
    switchContainer: {
      marginLeft: theme.spacing(2.5),
    },
  }),
);
